
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'connecting-to-a-policy-service',
	title: 'Connecting to a Policy Service'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "getting-started/connecting-to-a-policy-service",
  "id": "getting-started/connecting-to-a-policy-service",
  "isDocsHomePage": false,
  "title": "Connecting to a Policy Service",
  "description": "One of the most common use cases for Webhooks is to use them to create a policy in a policy administration system after a sale takes place.",
  "source": "@site/docs/getting-started/connecting-to-a-policy-service.md",
  "sourceDirName": "getting-started",
  "slug": "/getting-started/connecting-to-a-policy-service",
  "permalink": "/docs/getting-started/connecting-to-a-policy-service",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "connecting-to-a-policy-service",
    "title": "Connecting to a Policy Service"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Getting a Quote",
    "permalink": "/docs/getting-started/getting-a-quote"
  },
  "next": {
    "title": "Selecting relevant policy events",
    "permalink": "/docs/webhooks/select-events"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`One of the most common use cases for Webhooks is to use them to create a policy in a policy administration system after a sale takes place.`}</p>
    <p>{`In this case, you'll want to keep the custom code and mappings to your policy system confined to a Webhook. The overall flow will look something like this:`}</p>
    <p><img alt={"Sequence diagram"} src={require("!url-loader?limit=10000&name=assets/images/[name]-[hash].[ext]&fallback=file-loader!./example-policy-system-connection.png").default} /></p>
    <p>{`You will typically use Webhooks as the way to connect to other systems such as policy systems. For an overview of ways to connect,
`}<a parentName="p" {...{
        "href": "../integration-options"
      }}>{`click here`}</a>{`. For a step-by-step guide for using Webhooks, `}<a parentName="p" {...{
        "href": "./../webhooks/select-events"
      }}>{`click here`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
